export default __webpack_public_path__ + "static/media/10-gm-unachieved.0ccf10da.jpg";